import { useState } from 'react';

import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { currencyFormat } from '@/helpers/stringHelpers';

import ViewOfferingDialog from './ViewOfferingDialog';
import ViewOfferingSessionsDialog from '@/app/offeringSession/ViewOfferingSessionsDialog';

import { useOfferingObject } from '@/data/offering';

const SelectOfferingForCoachViewPage = ({ offeringId }) => {
  const offering = useOfferingObject(offeringId);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [isSessionsOpen, setIsSessionsOpen] = useState(false);

  const handleOpenSessions = (e) => {
    e.stopPropagation();
    setIsViewOpen(false);
    setIsSessionsOpen(true);
  };

  return (
    <>
      <Card key={offeringId} onClick={() => setIsViewOpen(true)}>
        <CardContent className="p-2 flex items-center justify-between">
          <div>
            <h3>{offering.name}</h3>
            <p className="text-sm text-muted-foreground">
              {offering.activity.title}
            </p>
          </div>
          <div className="flex gap-2 items-center">
            <Button size="sm">Book</Button>
            <p className="block w-[80px] text-right">
              {currencyFormat(offering.subtotal)}
            </p>
          </div>
        </CardContent>
      </Card>
      {isViewOpen && (
        <ViewOfferingDialog
          offeringId={offeringId}
          onClose={() => setIsViewOpen(false)}
          onBook={handleOpenSessions}
        />
      )}
      {isSessionsOpen && (
        <ViewOfferingSessionsDialog
          offeringId={offeringId}
          onClose={() => setIsSessionsOpen(false)}
        />
      )}
    </>
  );
};

export default SelectOfferingForCoachViewPage;
